export const articles = [
  {
    title: '日本中世における山林用益と築城',
    titleEn: 'Forest Use and Castle Construction in Medieval Japan',
    url: '/app/articles/240602_%E6%97%A5%E6%9C%AC%E4%B8%AD%E4%B8%96%E3%81%AB%E3%81%8A%E3%81%91%E3%82%8B%E5%B1%B1%E6%9E%97%E7%94%A8%E7%9B%8A%E3%81%A8%E7%AF%89%E5%9F%8E_%E6%96%B0%E8%B0%B7.pdf',
    createdAt: '2024-06-02',
  },
  {
    title: '本草綱目における可食「生食、煮食、蒸食、羹」記載植物のリスト',
    titleEn: 'List of plants listed as edible "raw, boiled, steamed, or soupy" in classical Chinese literature: the Compendium of Materia Medica',
    url: '/app/articles/240719_%E6%9C%AC%E8%8D%89%E7%B6%B1%E7%9B%AE%E3%81%AB%E3%81%8A%E3%81%91%E3%82%8B%E5%8F%AF%E9%A3%9F%E3%80%8C%E7%94%9F%E9%A3%9F%E3%80%81%E7%85%AE%E9%A3%9F%E3%80%81%E8%92%B8%E9%A3%9F%E3%80%81%E7%BE%B9%E3%80%8D%E8%A8%98%E8%BC%89%E6%A4%8D%E7%89%A9%E3%81%AE%E3%83%AA%E3%82%B9%E3%83%88_%E5%89%8D%E4%B8%AD_%E5%A4%A7%E7%AA%AA%E6%B0%8F.pdf',
    createdAt: '2024-07-19',
  },
  {
    title: 'ライフスタイルが変える植物利用の文化と景観－祈りの島、バリ島の暮らしより－',
    titleEn: 'Lifestyle Changes the Culture and Landscape of Plant Use -Insights from Life on Bali, the Island of Prayer.',
    url: '/app/articles/240722_%E3%83%A9%E3%82%A4%E3%83%95%E3%82%B9%E3%82%BF%E3%82%A4%E3%83%AB%E3%81%8C%E5%A4%89%E3%81%88%E3%82%8B%E6%A4%8D%E7%89%A9%E5%88%A9%E7%94%A8%E3%81%AE%E6%96%87%E5%8C%96%E3%81%A8%E6%99%AF%E8%A6%B3%EF%BC%8D%E7%A5%88%E3%82%8A%E3%81%AE%E5%B3%B6%E3%80%81%E3%83%90%E3%83%AA%E5%B3%B6%E3%81%AE%E6%9A%AE%E3%82%89%E3%81%97%E3%82%88%E3%82%8A%EF%BC%8D_%E5%A4%A7%E9%87%8E.pdf',
    createdAt: '2024-07-22',
  },
  {
    title: 'きのこ食習慣の二型性： 照葉樹林帯（乾燥保存）とブナ帯（塩漬け）',
    titleEn: 'Dimorphism of mushroom food customs: broad-leaved evergreen forest region (dried) and deciduous forest region (salted)',
    url: '/app/articles/240804_%E3%81%8D%E3%81%AE%E3%81%93%E9%A3%9F%E7%BF%92%E6%85%A3%E3%81%AE%E4%BA%8C%E5%9E%8B%E6%80%A7%EF%BC%9A+%E7%85%A7%E8%91%89%E6%A8%B9%E6%9E%97%E5%B8%AF%EF%BC%88%E4%B9%BE%E7%87%A5%E4%BF%9D%E5%AD%98%EF%BC%89%E3%81%A8%E3%83%96%E3%83%8A%E5%B8%AF%EF%BC%88%E5%A1%A9%E6%BC%AC%E3%81%91%EF%BC%89_%E7%A8%AE%E5%9D%82.pdf',
    createdAt: '2024-08-04',
  },
  // {
  //   title: '民族文化生物学研究会_キックオフ案内',
  //   titleEn: 'Announcement for the Kickoff Meeting of Society for Ethno-Cultural Biology',
  //   url: '/app/articles/250228_%E6%B0%91%E6%97%8F%E6%96%87%E5%8C%96%E7%94%9F%E7%89%A9%E5%AD%A6%E7%A0%94%E7%A9%B6%E4%BC%9A_%E3%82%AD%E3%83%83%E3%82%AF%E3%82%AA%E3%83%95%E6%A1%88%E5%86%85.pdf',
  //   createdAt: '2025-02-28',
  // },
  // 他の記事も同様に
];